module.exports = __webpack_public_path__ + "img/menu1.9dffd5d5.png";